import { IncomingMessage } from 'http';

import BaseAxiosRequest from '@r1-frontend/do-request/core/BaseAxiosRequest';
import { DoRequest } from '@r1-frontend/do-request/core/DoRequest';
import SSRAxiosRequest from '@r1-frontend/do-request/core/SSRAxiosRequest';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * временное решение исключительно для getInitialProps
 * @param req
 */
const getRequester = (req: IncomingMessage | undefined): DoRequest<IRequest> => {
    const baseRequest = req
        ? new SSRAxiosRequest(req)
        : new BaseAxiosRequest();

    return new DoRequest<IRequest>(baseRequest);
};

export default getRequester;
